import { TaskListWrapper, TaskRowAfterEntry, TaskRowEnd, TaskRowEntryWrapper } from "slot-definitions"
import { TailoredAudits } from "./tailored-audits"
import { JustifyTailoringButton } from "./justify-tailoring-button"
import { Justification } from "./justification"
import { AutoJustifyFromComment } from "./auto-justify-from-comment"
import { TaskTailored } from "./task-tailored"
import { OkCancelButtonsBefore } from "lib/@components/okCancel"
import { RemoveJustification } from "./remove-justification"
import { TailoredReference } from "./tailored-reference"
import { useState } from "react"
import { ToBeSaved } from "lib/@components/save-indicator/save-indicator"
import { Bound } from "lib/@components/binding/Bound"

export function TailoredAuditing({ children }) {
    const [pendingChange, setPendingChange] = useState(false)

    ToBeSaved("tailor").useEvent((value) => {
        setPendingChange(value)
    })

    TaskListWrapper.usePlug(<TailoredAudits />)
    TaskRowEntryWrapper.usePlug(<TaskTailored />)
    TaskRowEnd.usePlug(<JustifyTailoringButton />)
    TaskRowAfterEntry.usePlug(<Justification />)
    TaskRowAfterEntry.usePlug(<AutoJustifyFromComment />)
    OkCancelButtonsBefore.usePlug(<RemoveJustification />)

    return (
        <Bound pendingChange={pendingChange}>
            <TailoredReference>{children}</TailoredReference>
        </Bound>
    )
}
